import apiClient from "../../apiClient";
import { API_ENDPOINTS } from "../../config";

const doiService = {
  createDoi: async (formData) => {
    try {
      const response = await apiClient.post(API_ENDPOINTS.CRM.DOIS, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      return {
        success: response.responseCode === 201,
        doi: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.responseMessage || "Failed to create DOI"
      };
    }
  },

  updateDoi: async (doiId, formData) => {
    try {
      const response = await apiClient.patch(`${API_ENDPOINTS.CRM.DOIS}/${doiId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      return {
        success: response.responseCode === 200,
        doi: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.responseMessage || "Failed to update DOI"
      };
    }
  },

  getDoiById: async (doiId) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.CRM.DOIS}/${doiId}`);

      return {
        success: response.responseCode === 200 || response.success === true,
        doi: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.responseMessage || "Failed to retrieve DOI"
      };
    }
  },

  sendDoi: async (doiId, emailData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.CRM.DOIS}/${doiId}/send`, emailData);

      return {
        success: response.responseCode === 200 || response.success === true,
        messageId: response.data?.messageId,
        doi: response.data?.doi
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.responseMessage || "Failed to send DOI"
      };
    }
  },

  getAllDois: async (params = {}) => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.CRM.DOIS, { params });

      return {
        success: response.responseCode === 200,
        dois: response.data?.dois || [],
        pagination: response.data?.pagination || {}
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.responseMessage || "Failed to retrieve DOIs",
        dois: [],
        pagination: {}
      };
    }
  },

  getDashboardOverview: async (params = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.CRM.DOIS}/dashboard/overview`, { params });

      return {
        success: response.responseCode === 200 || response.success === true,
        dashboard: response.data || null
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.responseMessage || "Failed to retrieve DOI dashboard overview",
        dashboard: null
      };
    }
  },

  deleteDoi: async (doiId) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.CRM.DOIS}/${doiId}`);

      return {
        success: response.responseCode === 200,
        message: response.responseMessage
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.responseMessage || "Failed to delete DOI"
      };
    }
  }
};

export default doiService;
